module.exports = __webpack_public_path__ + "img/inventory-log-book_B09PVW2VW3.89a07367.jpg";